// src/components/Tooltip.tsx
import React, { useEffect, useState } from 'react';

interface TooltipProps {
    content: React.ReactNode;
    visible: boolean;
    x: number;
    y: number;
}

export default function Tooltip({ content, visible, x, y }: TooltipProps) {
    const [position, setPosition] = useState({ x, y });

    useEffect(() => {
        if (visible) {
            setPosition({ x, y });
        }
    }, [visible, x, y]);

    if (!visible) return <></>;

    return (
        <div
            className="fixed z-50 bg-white dark:bg-gray-800 p-3 rounded shadow-lg text-xs border border-gray-200 dark:border-gray-700 text-black dark:text-white"
            style={{
                left: `${position.x}px`,
                top: `${position.y}px`,
                transform: 'translate(10px, -100%)',
                maxWidth: '250px'
            }}
        >
            {content}
        </div>
    );
}